import React from 'react';

export default function ButtonShopFilter({ active, onClickAction, id, label }) {
    const buttonStyle = `py-1 px-4 w-20 rounded ${
      active === false
        ? "text-gray-100 hover:text-gray-700 bg-gray-500 hover:bg-gray-400 hover:shadow-sm"
        : "bg-gray-100 text-gray-800 border border-1 border-gray-500"
    } `; 
    
    return (
      <button
        onClick={onClickAction}
        id={id}
            className={buttonStyle}
            disabled={active}
      >
        {label}
      </button>
    );
}